import { StylesConfig } from 'react-select';
import styled from 'styled-components';
import { getTextStyle } from '../../../../../generic/content/texts/bou-text/text-style';
import { getTitleStyle } from '../../../../../generic/content/texts/bou-title/title-style';
import { BouColor } from '../../../../../generic/global/bou-colors';
import { defaultMobileBreakpointDEPRECATED, themeDEPRECATED } from '../../../../../generic/global/styles';
import { BouSpacingLevel, fluidMargin, fluidSpacing } from '../../../../../generic/layout/bou-spacing';

export const FormRow = styled.div`
  margin-top: ${themeDEPRECATED.rhythm(4)};
  display: flex;

  & + & {
    margin-top: ${themeDEPRECATED.rhythm(5)};
  }

  & > * + * {
    margin-left: 26px;
  }

  @media (max-width: ${defaultMobileBreakpointDEPRECATED}px) {
    margin-top: ${themeDEPRECATED.rhythm(4)};
    flex-direction: column;
    & > * + * {
      margin-left: 0;
      margin-top: 22px;
    }
  }
`;

export const FullRow = styled.div`
  width: 100%;
`;

export const RemoveLink = styled.a`
  ${getTextStyle({ size: 'xxs' })}
  color: ${themeDEPRECATED.colors.grayWarm()};
  cursor: pointer;
  &:hover {
    color: ${themeDEPRECATED.colors.black()};
  }
`;

export const Label = styled.label`
  display: block;
  ${getTextStyle({ size: 'xsmall' })}
  margin-bottom: 0;
`;

export const Example = styled.div`
  display: block;
  color: ${BouColor.TOOL_TEXT_DARK_GRAY};
  ${fluidSpacing('margin-bottom', BouSpacingLevel.MICRO)}
  ${getTextStyle({ size: 'xsmall' })}
`;

export const ProductRow = styled.div`
  ${fluidMargin(BouSpacingLevel.MICRO)}
  margin-left: 0;
  ${getTextStyle({ size: 'xsmall', isBold: true })}
`;

export const SubLabel = styled.div`
  ${fluidSpacing('margin-bottom', BouSpacingLevel.MICRO)}
  ${getTextStyle({ size: 'xsmall' })}
`;

export const ContributionModalTitle = styled.h5`
  ${getTitleStyle({ size: 'h5', withMargin: true })}
`;

export interface ProductCodeWithLabel {
  productCode: string;
  label: string;
  userCreated?: boolean;
}

export const getContributeSearchStyle = <OptionType = unknown>(_validResult?: boolean): StylesConfig<OptionType> => {
  return {
    control: (_base: any, _state: { isFocused: boolean }) => ({
      lineHeight: '1.5px',
      padding: '28px 4px 0px 24px',
      border: 0,
      display: 'flex',
    }),
  };
};

export const ContributionModalParagraph = styled.p`
  ${getTextStyle({ size: 'xsmall', isBold: false, withMargin: true })}
`;
